// S-3065: Legacy Library to Videos redirect component
// Preserves query params when redirecting from /library/* to /videos/*

import { Navigate, useLocation } from 'react-router-dom';

export function LibraryRedirect() {
  const location = useLocation();
  
  // Preserve query params and hash
  const newPath = location.pathname.replace(/^\/library/, '/videos');
  const search = location.search;
  const hash = location.hash;
  
  return <Navigate to={`${newPath}${search}${hash}`} replace />;
}

